import MessagesDemo from "../assets/images/messagesDemo.png";
import BookingDemo from "../assets/images/bookingDemo.png";
import PaymentDemo from "../assets/images/paymentDemo.png";
import ServicesDemo from "../assets/images/servicesDemo.png";

import FindStylists from "../assets/images/findStylists.png";
import ChooseLocation from "../assets/images/chooseLocation.jpg";
import CustomFrequency from "../assets/images/customFrequency.jpg";

import Messages from "../assets/images/messages.png";
import Portfolio from "../assets/images/portfolio.png";
import Ratings from "../assets/images/ratings.png";

import Services from "../assets/images/services.png";
import Rewards from "../assets/images/rewards.png";
import Help from "../assets/images/help.jpg";

export const heroBanners = [
  {
    id: 1,
    header: "Become a beauty professional on Book-d",
    body: "Join a curated network of beauty professionals. Whether you're a stylist, aesthetician or makeup artist, managing your business has never been easier.",
    image: MessagesDemo,
  },
  {
    id: 2,
    header: "Hassle free Scheduling",
    body: "Say goodbye to manually adding new bookings to your calendar. With Book-d, all bookings are synced to your calendar in real-time.",
    image: BookingDemo,
  },
  {
    id: 3,
    header: "Secure Payments",
    body: "Receive deposits and payments on time and in full with protection from trusted payment providers.",
    image: PaymentDemo,
  },
  {
    id: 4,
    header: "All in one Place",
    body: "Focus on your business while we take care of the boring admin stuff such as payments and invoicing. ",
    image: ServicesDemo,
  },
];

export const faqs = [
  {
    id: "a",
    title: "What is Book-d?",
    body: "Book-d helps Black hairstylists manage bookings, get paid, and attract new clients all in one place.",
  },
  {
    id: "b",
    title: "How much does it cost?",
    body: "Depends on the plan you choose: Starter (Free) or Premium (£9.99/month).",
  },
  {
    id: "c",
    title: "What is included in the Starter plan?",
    body: "Starter is free and includes everything you need to get booked:\n\n• Client messaging\n• Booking calendar management\n• Secure payments via Stripe\n• Personalised booking link for socials\n• Listing on the Book-d directory*\n\n*10% commission applies to bookings via the Book-d directory.",
  },
  {
    id: "d",
    title: "What is included in the Premium plan?",
    body: "Premium costs £9.99/month and includes tools to grow your brand and income:\n\n• Commission-free bookings\n• Custom business name & logo\n• Additional team members\n• Create discount codes\n• Track performance with analytics.",
  },
  {
    id: "e",
    title: "Are there any hidden fees?",
    body: "No - there are no hidden fees on Book-d. We don't charge a monthly fee for our Starter plan, and you'll always know exactly what you're paying for if you choose to upgrade to the Premium plan. Please note that if you are on the Starter plan, any bookings received via the Book-d directory will be subject to 10% commission.",
  },
  {
    id: "f",
    title: "How long does it take to get set up?",
    body: "Getting started with Book-d is quick and simple. Create an account, set up your payments, add your services and availability, upload your photos, and you're ready to go live. We've designed onboarding to be simple and intuitive, but our team is always on hand to support.",
  },
  {
    id: "g",
    title: "Can I switch to Book-d if I already use another booking platform?",
    body: "Absolutely - and it's easy. Whether you're coming from Fresha, Acuity, or another tool, our team is available to help you transfer over your services and availability to Book-d. Many stylists switch because Book-d is built specifically for Black hairstylists and beauty professionals, offering a smoother booking experience and better visibility in front of the right clients. You can even bring your existing clients over and message them directly through our app.",
  },
];

export const clientFaqs = [
  {
    id: "a",
    title: "What services can I book on the platform?",
    body: "You can book any beauty service tailored to textured hair, including popular styles like knotless braids, loc maintenance, natural hair styling, twists, protective styles, and specialised color services.",
  },
  {
    id: "b",
    title:
      "Can I choose to have the stylist come to me, or do I have to go to a salon?",
    body: "You have total booking flexibility. You can easily filter searches to choose your service location, booking either a traditional salon appointment or selecting an available stylist who provides mobile services.",
  },
  {
    id: "c",
    title:
      "Can I book multiple services (like a wash and braid service) with the same stylist?",
    body: "Yes, absolutely. During the booking process, you can select and combine multiple services offered by a single stylist to create one comprehensive appointment.",
  },
  {
    id: "d",
    title: "Can I ask a stylist questions before I confirm my booking?",
    body: "Yes. You can use the in-app messenger to communicate directly with your chosen stylist to ask questions about the service, confirm details, or send inspiration photos before finalising your appointment.",
  },
  {
    id: "e",
    title: "What happens if I have an issue with the service I received?",
    body: "Your booking includes dispute management. If a problem arises, we are available to step in, mediate, and help ensure a fair and timely resolution between you and the stylist.",
  },
];

export type FeatureItem = {
  title: string;
  description: string;
  image?: string;
};

export type FeatureGroup = {
  tab: string;
  items: FeatureItem[];
};

export const featureGroups: FeatureGroup[] = [
  {
    tab: "Total Booking Flexibility",
    items: [
      {
        title: "Schedule on Your Terms",
        description:
          "Find a stylist closer to you at a specific time that works for your schedule, allowing you to book anytime and anywhere, 24/7",
        image: FindStylists,
      },
      {
        title: "Choose Your Service Location",
        description:
          "Select your preferred setting, whether it's booking a traditional salon appointment or scheduling a skilled professional to come to your home",
        image: ChooseLocation,
      },
      {
        title: "Effortless Recurring Appointments",
        description:
          "Easily schedule and manage future appointments with your favorite stylists by setting up convenient recurring bookings.",
        image: CustomFrequency,
      },
    ],
  },
  {
    tab: "Confidence & Communication",
    items: [
      {
        title: "Visual Style Confirmation",
        description:
          "Use the secure in-app messenger to communicate directly with your stylist and send photos of your desired hairstyle for confirmation.",
        image: Messages,
      },
      {
        title: "Reliable Work Portfolios",
        description:
          "View the stylist's previous work in their portfolio to gain inspiration and confidence that they can flawlessly achieve your desired look.",
        image: Portfolio,
      },
      {
        title: "Authentic Peer Reviews",
        description:
          "Make informed decisions based on honest ratings and reviews from clients with similar hair texture who have previously received the same service.",
        image: Ratings,
      },
    ],
  },
  {
    tab: "Financial Security & Rewards",
    items: [
      {
        title: "Transparent Pricing Guarantee",
        description:
          "View clear, upfront pricing for all services and stylists, eliminating unexpected fees and ensuring you know the cost before you book.",
        image: Services,
      },
      {
        title: "Exclusive Loyalty Rewards",
        description:
          "Earn savings and access special discounts through the loyalty card scheme, rewarding you for choosing us for your ongoing hair care needs.",
        image: Rewards,
      },
      {
        title: "Platform Dispute Management",
        description:
          "If any issues arise, the booking platform is there to mediate and manage disputes, ensuring a fair resolution for both the customer and the stylist.",
        image: Help,
      },
    ],
  },
];
